// Loads the PayPal JS SDK twice under separate namespaces: one for subscriptions, one for one-off orders.
import { api } from './hubApi';

let cfgP = null;
const loaded = {};
export const billingConfig = () => (cfgP ||= api('/billing/config'));

export async function loadPayPal(kind) { // kind: 'sub' | 'order'
  const cfg = await billingConfig();
  if (!cfg.configured) throw Object.assign(new Error('PAYMENTS_NOT_CONFIGURED'), { code: 'PAYMENTS_NOT_CONFIGURED' });
  const ns = kind === 'sub' ? 'paypal_sub' : 'paypal_order';
  if (window[ns]) return window[ns];
  if (!loaded[ns]) {
    const params = new URLSearchParams({ 'client-id': cfg.clientId, currency: 'AUD', components: 'buttons' });
    if (kind === 'sub') { params.set('vault', 'true'); params.set('intent', 'subscription'); } else params.set('intent', 'capture');
    loaded[ns] = new Promise((res, rej) => {
      const s = document.createElement('script');
      s.src = 'https://www.paypal.com/sdk/js?' + params.toString();
      s.setAttribute('data-namespace', ns);
      s.onload = () => res(window[ns]); s.onerror = () => rej(Object.assign(new Error('PAYPAL_LOAD_FAILED'), { code: 'PAYPAL_LOAD_FAILED' }));
      document.head.appendChild(s);
    });
  }
  return loaded[ns];
}
